import React from "react";

/**
 * Bandeau discret avec les vrais logos des marques électriques partenaires.
 * Logos hébergés localement dans /public/brands/ — sources Wikimedia Commons + sites officiels.
 *
 * Affichage statique en grille (responsive) — niveau de gris + saturation au survol.
 */
const BRANDS = [
  { name: "Legrand", file: "/brands/legrand.svg" },
  { name: "Schneider Electric", file: "/brands/schneider.svg" },
  { name: "Hager", file: "/brands/hager.svg" },
  { name: "Siemens", file: "/brands/siemens.svg" },
  { name: "ABB", file: "/brands/abb.svg" },
  { name: "Philips", file: "/brands/philips.svg" },
  { name: "Atlantic", file: "/brands/atlantic.svg" },
  { name: "Delta Dore", file: "/brands/deltadore.png" },
];

export default function BrandsStrip() {
  return (
    <section
      data-testid="brands-strip"
      className="bg-white border-y border-slate-200 py-10 lg:py-12"
      aria-label="Marques électriques que nous installons"
    >
      <div className="container-x">
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="accent-bar" style={{ width: 24, height: 2 }} />
          <p className="uppercase tracking-[0.2em] text-[11px] font-semibold text-slate-500">
            Marques que nous installons et dépannons
          </p>
          <span className="accent-bar" style={{ width: 24, height: 2 }} />
        </div>
        <ul className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-x-6 gap-y-8 items-center">
          {BRANDS.map((b) => (
            <li
              key={b.name}
              data-testid={`brand-${b.name.toLowerCase().replace(/\s/g, '-')}`}
              className="flex items-center justify-center h-10"
              title={b.name}
            >
              <img
                src={b.file}
                alt={`Logo ${b.name}`}
                loading="lazy"
                className="max-h-9 max-w-[120px] object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                onError={(e) => {
                  const fallback = document.createElement("span");
                  fallback.textContent = b.name;
                  fallback.className = "text-slate-600 font-semibold text-sm whitespace-nowrap";
                  e.target.replaceWith(fallback);
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
